import { ChatItem, ChatItemProps } from '@ant-design/pro-chat';
import PropTypes from 'prop-types';
import './ChatItem.less';

interface CustomChatItemProps {
  message: string;
}

const CustomChatItem: React.FC<CustomChatItemProps> = ({ message }) => {
  const control: ChatItemProps = {
    message,
    placement: 'left',
    type: 'block',
    avatar: { avatar: '', backgroundColor: 'transparent', title: '' },
  };

  return <ChatItem {...control} className="custom-chat-item" />;
};

CustomChatItem.propTypes = {
  message: PropTypes.string.isRequired,
};

export default CustomChatItem;
